import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalActionsDownloadIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-actions-download"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M17.5 17.5h-15M5 9.167l5 5 5-5m-5 5V2.5"
        />
    </svg>
);
const Memo = memo(ImageModalActionsDownloadIcon);
export default Memo;
